import { gif, toast } from '../components/message'
import { estabelecimento } from '../Estabelecimento/estabelecimento'
import { exibeSaboresAdicionados } from '../mobile'
import {
  createElement,
  createMessageBox,
  formatDecimal,
  formatMoney,
  sentryError,
  track,
} from '../utils'

export const separaItensPedido = (itens) => {
  /* Separa os itens do pedido em unidades, para que na impressão 
       seja mais fácil identificar os itens que foram adicionados */
  const newOrderItens = []
  itens.forEach((item, indexItem) => {
    if (item.Quantidade > 1 && item.Adicionais.length > 0) {
      for (
        let indexQuantidade = 0;
        indexQuantidade < item.Quantidade;
        indexQuantidade++
      ) {
        const newItem = { ...item }

        // Cria um noco código ticks, para que o mogo gourmet entenda que são itens diferentes

        // Obtém o ticks atual e faz um cálculo para garantir que o valor seja único para cada item
        const ticks = new Date().getTime() + indexItem + indexQuantidade

        newItem.CodTicks = (ticks * 10000 + 621355968000000000).toString()

        newItem.Quantidade = 1
        newItem.QuantidadeAPagar = 1

        const valorTotalAdicionais = newItem.Adicionais.reduce(
          (total, adicional) => total + adicional.ValorTotal,
          0,
        )

        newItem.ValorAPagar = (newItem.ValorUnitario + valorTotalAdicionais) * newItem.Quantidade
        newItem.ValorTotal = (newItem.ValorUnitario + valorTotalAdicionais) * newItem.Quantidade
        newItem.ValorComAdicionais = (newItem.ValorUnitario + valorTotalAdicionais) * newItem.Quantidade

        newOrderItens.push(newItem)
      }
    } else {
      newOrderItens.push(item)
    }
  })

  return newOrderItens
}

export const rastreioPedido = (storeOrder) => {
  try {
    const valorTotal =
      typeof storeOrder.valorTotal === 'string'
        ? storeOrder.valorTotal.replace(',', '.')
        : storeOrder.valorTotal
    track('Pedido', {
      estabelecimento: estabelecimento.urlEmpresa,
      valorTotal,
      itens: [storeOrder.Itens.map((item) => item.Produto_Produto)],
      pagamento: estabelecimento.pagamento.metodos.filter(
        (metodo) => metodo.Id == storeOrder.CodTipoPagamento,
      )[0].Descricao,
    })
  } catch (e) {
    sentryError.exception('track pedido -' + e)
  }
}

export const formataValoresPedido = (storeOrder) => {
  storeOrder.ValorDesconto = formatDecimal(storeOrder.ValorDesconto)
  storeOrder.ValorTotalPedido = formatDecimal(
    storeOrder.valorTotal + (storeOrder.TaxaEntrega || 0),
  )
  storeOrder.valorTotal = formatDecimal(storeOrder.valorTotal)
  storeOrder.TaxaEntrega = formatDecimal(storeOrder.TaxaEntrega)
  storeOrder.TrocoDelivery = formatDecimal(storeOrder.TrocoDelivery)

  storeOrder.ReaisDesconto &&
    (storeOrder.ReaisDesconto = formatDecimal(storeOrder.ReaisDesconto))
}

export const agrupaItensPedido = (pedidos) => {
  pedidos.forEach((pedido) => {
    const itensAgrupados = []

    pedido.Itens.forEach((item, index) => {
      if (item.Sabores && item.Sabores.length > 0) {
        itensAgrupados.push(item)
        return
      }

      item.Adicionais.forEach((adicional) => {
        if (!adicional.IdAdicional && adicional.Adicional) {
          adicional.IdAdicional = adicional.Adicional.Id
        }
      })

      if (!item.IdProduto) {
        item.IdProduto = item.CodProduto
      }

      if (itensAgrupados.length === 0) {
        itensAgrupados.push(item)
      } else {
        const itemAgrupado = itensAgrupados.find((itemAgrupado) => {
          if (itemAgrupado.IdProduto === item.IdProduto) {
            // Se não existir adicionais nos dois itens, o item é equivalente
            if (
              item.Adicionais.length == 0 &&
              itemAgrupado.Adicionais.length == 0
            ) {
              return true
            } else {
              // Percorre os adicionais para validar se todos são equivalentes
              let adicionaisEquivalentes = true

              item.Adicionais.forEach((adicional) => {
                if (
                  !itemAgrupado.Adicionais.find(
                    (adicionalAgrupado) =>
                      adicionalAgrupado.IdAdicional === adicional.IdAdicional,
                  )
                ) {
                  adicionaisEquivalentes = false
                }
              })

              return adicionaisEquivalentes
            }
          }
        })
        if (itemAgrupado) {
          item.Adicionais.forEach((adicional) => {
            const adicionalItemAgrupado = itemAgrupado.Adicionais.find(
              (adicionalAgrupado) =>
                adicionalAgrupado.IdAdicional === adicional.IdAdicional,
            )
            adicionalItemAgrupado.Quantidade += adicional.Quantidade
            adicionalItemAgrupado.ValorTotal =
              adicionalItemAgrupado.Quantidade *
              adicionalItemAgrupado.ValorUnitario
          })

          itemAgrupado.Quantidade += item.Quantidade
        } else {
          itensAgrupados.push(item)
        }
      }
    })

    pedido.Itens = itensAgrupados
  })
}

export function exibeAdicionaisSabores(
  objetoSabor,
  idPizza,
  callback,
  objetoSaborAdicionado,
  storProduto,
) {
  const idSabor = objetoSabor.Sabor_Id

  const buttons = [
    {
      content: 'cancelar',
      class: 'btn-transparent flex-1',
      callback: (dialog) => {
        dialog.remove()
      },
    },
    {
      content: 'Continuar',
      class: 'btn-azul flex-1',
      callback: (wrapper) => {
        const adicionaisSelecionados = selectAll('input:checked', wrapper, true)
        const adicionaisSabor = adicionaisSelecionados.map((input) => {
          return {
            id: input.dataset.id,
            descricao: input.dataset.descricao,
            preco: Number(input.dataset.preco),
          }
        })

        wrapper.remove()
        callback && callback(adicionaisSabor)
      },
    },
  ]

  // Se o item já está no carrinho
  // if (objetoSaborAdicionado) {
  //   buttons.unshift({
  //     content: "remover",
  //     class: 'btn-azul btn-remover flex-1',
  //     callback: (wrapper) => {
  //       wrapper.remove()
  //       console.log(storProduto)
  //       storProduto = storProduto.Sabores.filter(objSabor => objSabor !== objetoSaborAdicionado)
  //       console.log(storProduto)
  //       toast('Sabor removido com sucesso!')

  //       const wrapperSabor = select('[cod-sabor="' + idSabor + '"]')
  //       const quantidadeElemento = select('.qtd-value', wrapperSabor)
  //       let quantidade = Number(quantidadeElemento.textContent)
  //       quantidadeElemento.textContent = quantidade - 1
  //       quantidade == 0 && sabor.classList.remove('item-adicionado')
  //       exibeSaboresAdicionados()
  //     }
  //   })
  // }

  axios
    .get('Cadastros/GetAdicionaisSabor', {
      params: {
        idSabor: Number(idSabor),
        idPizza: Number(idPizza),
        dbName: estabelecimento.urlEmpresa,
      },
    })
    .then((response) => {
      const loaderSabor = select('.loader-sabor')
      loaderSabor && loaderSabor.remove()

      if (response.data.length == 0) {
        callback && callback()
        return
      }

      let htmlSabores = ''
      const sabor = response.data.forEach((adicional) => {
        const adicionalInlcuso = objetoSaborAdicionado
          ? objetoSaborAdicionado.Adicionais.find(
              (adicionalIncluso) => adicionalIncluso.id == adicional.Adicional,
            )
          : false

        htmlSabores += `
      <label class="flex flex-between font-13 text-gray-600 font-weight-500 border-top">
        <div class="flex gap-4">
          <input 
          type="checkbox" 
          class="checkbox" 
          data-id="${adicional.Adicional}"
          data-descricao="${adicional.Descricao}"
          data-preco="${adicional.Preco}"
          ${adicionalInlcuso ? 'checked' : ''}
          />
          <div>${adicional.Descricao}</div>
        </div>
        <div class="preco">${formatMoney(adicional.Preco)}</div>
      </label>  
      `
      })

      createMessageBox({
        class: 'dialog-no-padding dialog-adicionais-sabores',
        content: `
        <div class="flex flex-column">
          <div class="descricao-sabor p-12">
            <div class="font-14 text-gray-900 font-800 font-laranja">${objetoSabor.Sabor_Descricao.trim()}</div>
            <div class="font-12">${objetoSabor.DescricaoDoSabor ?? ""}</div>
          </div>
          <div class="border-top font-12 font-700 p-12">Deseja algum adicional neste sabor?</div>
          <div class="flex flex-column adicionais-sabores">
            ${htmlSabores}
          </div>  
      
        </div>
        `,
        closeOnClickOutside: false,
        buttons,
      })
    })
}

export function exibePagamentoQRCode() {
  const wrapper = createElement('div', {}, ``)

  document.body.appendChild(wrapper)
}

export function getCodTicks() {
  return (new Date().getTime() * 10000 + 621355968000000000).toString()
}

